/* eslint-disable import/order */
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { EntitlementsEntitlementsQueryResource } from '@jira/router-resources__service-desk-customer-service-organization-details/src/EntitlementsEntitlementsQueryResource.tsx';
import { OrganizationDetailsPageQueryResource } from '@jira/router-resources__service-desk-customer-service-organization-details/src/OrganizationDetailsPageQueryResource.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { jsmEmailDomainsListResource } from '@jira/router-resources__get-email-domains-list/src/jsmEmailDomainsListResource.tsx';
import { productsJsmOrganizationDetailsResource } from '@jira/router-resources__organization-details/src/productsJsmOrganizationDetailsResource.tsx';
import { servicedeskOrganizationDetailsRoute } from '@jira/router-routes__servicedesk-organizations-routes/src/servicedeskOrganizationDetailsRoute.tsx';
// eslint-disable-next-line jira/restricted/@jira+servicedesk__common-toPackageName
import { APP_NAMES, toPackageName } from '@jira/servicedesk__common/src/toPackageName.tsx';
import {
	getServiceDeskNavigationResources,
	getServicedeskPageContextResources,
} from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import { ServicedeskOrganizationDetails, LazyServicedeskOrganizationDetails } from './ui/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

export const servicedeskOrganizationDetailsRouteEntry: Route = createEntry(
	servicedeskOrganizationDetailsRoute,
	() => ({
		group: 'servicedesk',
		layout: serviceProjectLayout,

		navigation: {
			menuId: MenuIdProjects,
		},

		// eslint-disable-next-line no-restricted-syntax
		component: ServicedeskOrganizationDetails,
		forPaint: [LazyAtlassianNavigation, LazyServicedeskOrganizationDetails],
		perfMetricKey: 'jsm-organization-details-component-load',

		meta: {
			reporting: {
				id: APP_NAMES.ORGANIZATION_DETAILS,
				packageName: toPackageName(APP_NAMES.ORGANIZATION_DETAILS),
				teamName: 'boysenberry',
			},
		},

		resources: [
			...getServiceDeskNavigationResources(),
			...getServicedeskPageContextResources(),
			getConsolidationStateResource(),
			EntitlementsEntitlementsQueryResource,
			OrganizationDetailsPageQueryResource,
			productsJsmOrganizationDetailsResource,
			jsmEmailDomainsListResource,
		],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
